import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function FeaturedProducts() {
  const categories = [{
    title: 'THE SYSTEM',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iAiwq9PbfYEjJUKwKMkQNp/image.png',
    items: ['Evacuation Displays', 'I.D. Signs', 'Emergency Employee Pamphlets', 'Fire Department Information']
  }, {
    title: 'I.D. Sign Catalog',
    image: 'https://images.unsplash.com/photo-1582139329536-e7284fece509?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    items: ['Fire Signs', 'Exit Signs', 'Safety Signs', 'OSHA Safety Signs', 'Miscellaneous Signs']
  }, {
    title: 'SPECIALTY PROGRAMS',
    image: 'https://images.unsplash.com/photo-1557318041-1ce374d55ebf?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    items: ['Perimeter Security', 'Site Access', 'Pedestrian and Vehicle Safety', 'Visitor Safety Cards', 'E.R.T. Logos and Decals']
  }];
  return <section id="products" className="py-16 bg-gray-50" data-id="element-42">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl font-bold mb-4" data-id="element-45">Our Fire Safety Solutions</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-46">
            For over four decades, we've been the go-to source for expertly
            crafted "You Are Here" evacuation displays and comprehensive
            emergency identification solutions—helping businesses across
            industries stay fully compliant and prepared.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-47">
          {categories.map((category, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:-translate-y-1 hover:shadow-lg" data-id="element-48">
              <div className="p-6 border-b border-gray-100" data-id="element-49">
                <h3 className="text-xl font-semibold mb-4 text-center text-red-700" data-id="element-50">
                  {category.title}
                </h3>
                <ul className="space-y-2" data-id="element-51">
                  {category.items.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-52">
                      <span className="text-red-600 mr-2" data-id="element-53">•</span>
                      <span data-id="element-54">{item}</span>
                    </li>)}
                </ul>
              </div>
              <div className="p-4 bg-gray-50" data-id="element-55">
                <a href="#" className="inline-flex items-center font-medium text-red-600 hover:text-red-700" data-id="element-56">
                  View Details
                  <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-57" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}